"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ExtendedAxiosError = require("./ExtendedAxiosError");
/**
 * Generic error caused by failed call to the graphql server
 */ var GraphqlError = /*#__PURE__*/ function(_ExtendedAxiosError_ExtendedAxiosError) {
    _inherits(GraphqlError, _ExtendedAxiosError_ExtendedAxiosError);
    function GraphqlError(axiosError) {
        _class_call_check(this, GraphqlError);
        var _this;
        _this = _call_super(this, GraphqlError, [
            axiosError
        ]);
        (0, _defineProperty2.default)(_this, "graphqlVariables", void 0);
        (0, _defineProperty2.default)(_this, "graphqlQuery", void 0);
        _this.name = 'GraphqlError';
        var config = axiosError.config;
        var data = null;
        try {
            if (_type_of(config === null || config === void 0 ? void 0 : config.data) === 'object') {
                data = config.data;
            } else if (typeof (config === null || config === void 0 ? void 0 : config.data) === 'string') {
                data = JSON.parse(config.data);
            }
        } catch (e) {
        // If we cannot parse the data, we just ignore it
        // This is usually the case when the data is not JSON, but some other format
        }
        var _data_variables;
        _this.graphqlVariables = (_data_variables = data === null || data === void 0 ? void 0 : data.variables) !== null && _data_variables !== void 0 ? _data_variables : null;
        var _data_query;
        _this.graphqlQuery = (_data_query = data === null || data === void 0 ? void 0 : data.query) !== null && _data_query !== void 0 ? _data_query : null;
        return _this;
    }
    return GraphqlError;
}(_ExtendedAxiosError.ExtendedAxiosError);
exports.GraphqlError = GraphqlError; //# sourceMappingURL=GraphqlError.js.map
